/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TTLORouteLocationResponse,
    TTLORouteLocationResponseFromJSON,
    TTLORouteLocationResponseFromJSONTyped,
    TTLORouteLocationResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOCriteriaForRouteResponse
 */
export interface TTLOCriteriaForRouteResponse {
    /**
     * 
     * @type {TTLORouteLocationResponse}
     * @memberof TTLOCriteriaForRouteResponse
     */
    from?: TTLORouteLocationResponse;
    /**
     * 
     * @type {TTLORouteLocationResponse}
     * @memberof TTLOCriteriaForRouteResponse
     */
    to?: TTLORouteLocationResponse;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOCriteriaForRouteResponse
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOCriteriaForRouteResponse
     */
    isOutbound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOCriteriaForRouteResponse
     */
    match?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TTLOCriteriaForRouteResponse
     */
    order?: number;
}

export function TTLOCriteriaForRouteResponseFromJSON(json: any): TTLOCriteriaForRouteResponse {
    return TTLOCriteriaForRouteResponseFromJSONTyped(json, false);
}

export function TTLOCriteriaForRouteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOCriteriaForRouteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : TTLORouteLocationResponseFromJSON(json['from']),
        'to': !exists(json, 'to') ? undefined : TTLORouteLocationResponseFromJSON(json['to']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
        'match': !exists(json, 'match') ? undefined : json['match'],
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}

export function TTLOCriteriaForRouteResponseToJSON(value?: TTLOCriteriaForRouteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': TTLORouteLocationResponseToJSON(value.from),
        'to': TTLORouteLocationResponseToJSON(value.to),
        'exclude': value.exclude,
        'isOutbound': value.isOutbound,
        'match': value.match,
        'order': value.order,
    };
}


